import { render, staticRenderFns } from "./SolutionRpa.vue?vue&type=template&id=03b80f73"
import script from "./SolutionRpa.vue?vue&type=script&lang=js"
export * from "./SolutionRpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports